import React from 'react';

const ConductSiteDocumentsPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>Static Site Documents Page</h3>
    </div>
  );
};

export default ConductSiteDocumentsPage;
